export default {

    emits: ['click'],

    props: {
        clickable: {
            type: Boolean,
            default: false
        },

        // Whether the element can not be clicked
        disabled: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        isClickable() {
            return this.clickable;
        }
    },

    methods: {
        handleClick(event) {
            if (!this.disabled) {
                this.$emit('click', event)
            }
        }
    }
}
